import script from "./scrollToError.vue?vue&type=script&lang=js"
export * from "./scrollToError.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__